import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	List,
	ListItem,
	Stack,
	Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "../../../../../../../assets/icons";

type DeleteRowsDialogProps = {
	open: boolean;
	handleClose: VoidFunction;
	count?: number;
	onDelete?: VoidFunction;
	isLoading?: boolean;
};

export const DeleteRowsDialog = ({ open, handleClose, count, onDelete, isLoading }: DeleteRowsDialogProps) => {
	const { t } = useTranslation("common");

	return (
		<Dialog onClose={handleClose} aria-labelledby="node-dialog-title" open={open} maxWidth="sm" fullWidth>
			<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 2 }}>
				<DialogTitle component="h5" id="node-dialog-title" sx={{ p: 0 }}>
					{count ? t("delete rows dialog/title", { count }) : t("delete rows dialog/title single")}?
				</DialogTitle>
				<IconButton aria-label="close" onClick={handleClose}>
					{<CloseIcon />}
				</IconButton>
			</Stack>

			<Divider sx={{ mx: 2 }} />

			<DialogContent sx={{ p: 2 }}>
				<List sx={{ listStyleType: "disc", pl: 4, py: 0 }}>
					<ListItem sx={{ display: "list-item", p: 0 }}>
						<Typography variant="body2">{t("delete rows dialog/this action cannot be undone")}</Typography>
					</ListItem>
					<ListItem sx={{ display: "list-item", p: 0 }}>
						<Typography variant="body2">
							{t(
								"delete rows dialog/the data associated with the operational unit will no longer be accessible"
							)}
						</Typography>
					</ListItem>
				</List>
			</DialogContent>

			<Divider sx={{ mx: 2 }} />

			<DialogActions sx={{ p: 2 }}>
				<Stack width={"100%"} direction="row" spacing={2} justifyContent={"space-between"}>
					<Button onClick={handleClose} color="primary" variant="outlined" disabled={isLoading}>
						{t("common:cancel")}
					</Button>
					<Button
						onClick={onDelete}
						color="primary"
						variant="contained"
						disabled={isLoading}
						startIcon={isLoading && <CircularProgress size={18} />}
					>
						{t("common:delete")}
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};
